export default "__VITE_ASSET__DSjPFYWf__"